import { Controller } from "stimulus"
import { post } from '@rails/request.js'
export default class extends Controller {
}
